import '../accountType.scss';

import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import accountTypeActions from 'actions/accountTypeActions';
import optionsActions from 'actions/optionsActions';
import { ReducedQuestions } from './ReduceQuestions/ReducedQuestions';
import { DefaultQuestions } from './DefaultQuestions/DefaultQuestions';
import { goToErrorsView } from 'actions/errorViewNavigation';
import { getIsAuthorized } from 'utilities/jointHolders/holderTypes';

const SelfEmployedComponent = ({
    accountTypeActions,
    commonList,
    disabled,
    formActions,
    shouldRenderTgssQuestion,
    userProfile,
    userProfileForm,
    ...props
}) => {
    const [showCompanyNameWarning, setShowCompanyNameWarning] = useState(false);

    const { accessToken, isJointHolder, jointHolderType } = userProfile;

    const onHandleSave = (name, value) => {
        const data = { [name]: value };
        accountTypeActions.saveSelfEmployedInformation(data, accessToken, (saved, errors) => {
            if (!saved) {
                errors['6002'] && goToErrorsView({ errorCode: 6002 });
            }
        });
    };

    return isJointHolder && getIsAuthorized(jointHolderType) ? (
        <ReducedQuestions
            disabled={disabled}
            formActions={formActions}
            onHandleSave={onHandleSave}
            shouldRenderTgssQuestion={shouldRenderTgssQuestion}
            showCompanyNameWarning={showCompanyNameWarning}
            setShowCompanyNameWarning={setShowCompanyNameWarning}
            userProfile={userProfile}
            userProfileForm={userProfileForm}
            {...props}
        />
    ) : (
        <DefaultQuestions
            commonList={commonList}
            disabled={disabled}
            formActions={formActions}
            onHandleSave={onHandleSave}
            shouldRenderTgssQuestion={shouldRenderTgssQuestion}
            showCompanyNameWarning={showCompanyNameWarning}
            setShowCompanyNameWarning={setShowCompanyNameWarning}
            userProfile={userProfile}
            userProfileForm={userProfileForm}
            {...props}
        />
    );
};

const mapStateToProps = state => ({
    extraData: state.extraData,
    focus: state.focus,
    options: state.options,
});

const mapDispatchToProps = dispatch => ({
    accountTypeActions: bindActionCreators(accountTypeActions, dispatch),
    optionsActions: bindActionCreators(optionsActions, dispatch),
    goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
});

export const SelfEmployed = connect(mapStateToProps, mapDispatchToProps)(SelfEmployedComponent);
